export const DATE_FORMAT_US = 'MM-DD-YYYY';
export const DATE_FORMAT_US_SLASH = 'MM/DD/YYYY';
export const DATE_FORMAT_BACKEND = 'YYYY-MM-DD';
export const DATE_FORMAT_SENTENCE = 'MMM D, YYYY';
export const DATE_TIME_FORMAT_SENTENCE = 'MMM D, YYYY [at] h:mm A';
export const DATE_LOCALE = 'en-US';
export const TIMEZONE_EST = 'America/New_York';
